import { useEffect } from "react";
import useAuth from "auth/useAuth";
import Loader from "utils/Loader";

const SSOTokenFetch = () => {
  const { loadToken } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tempCode = params.get("code");
    const state = params.get("state");
    loadToken(tempCode, state);
  }, []);

  return <Loader loading />;
};

export default SSOTokenFetch;
